import downloadFileFromDatalake from '@/utils/downloadFileFromDatalake';

const downloadFile = async (fileId: string, fileName: string, retry = 3) => {
  try {
    const fileResponse = await downloadFileFromDatalake(fileId);

    const url = window.URL.createObjectURL(fileResponse?.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading file:', error);
    if (retry > 0) {
      setTimeout(() => downloadFile(fileId, fileName, retry - 1), 500);
    }
  }
};

export default downloadFile;
